import { Col, DatePicker, Divider, Row } from "antd";
import dayjs from "dayjs";
import React, { Fragment, useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { loadDashboardData } from "../../../redux/rtk/features/dashboard/dashboardSlice";
import NewDashboardCard from "../../Card/Dashboard/NewDashboardCard";
import UserPrivateComponent from "../../PrivateRoutes/UserPrivateComponent";

import axios from "axios";
import getCompanyIdFromToken from "../../../utils/getCompanyIdFromToken";
import SetupSteps from "./setUpSteps";



let startdate = dayjs().toDate();
let enddate = dayjs().toDate();


const DemoLine = () => {
  const data = useSelector((state) => state.dashboard.list?.workHoursByDate);

  const cardInformation = useSelector((state) => state.dashboard.list);
  const [selectedDates, setSelectedDates] = useState({
    startdate: dayjs().format("YYYY-MM-DD"),
    enddate: dayjs().format("YYYY-MM-DD"),
  });
  console.log("dashboard list>>", cardInformation);

  const dispatch = useDispatch();

  // const defaultValue = [moment(startdate), moment(enddate)];
	const defaultValue = [dayjs(startdate), dayjs(enddate)];

  const [isOnboardingComplete, setIsOnboardingComplete] = useState(true);
  // const [isOnboardingComplete, setIsOnboardingComplete] = useState(false);

  useEffect(() => {
    const fetchOnboardingProgress = async () => {
      try {
        const companyId = getCompanyIdFromToken();
        if (!companyId) {
          return;
        }

        const response = await axios.get(`/initialSetUp/onboarding-progress?companyId=${companyId}`);
        const allCompleted = response.data.every(step => step.completed);
        setIsOnboardingComplete(allCompleted);
      } catch (error) {
        console.error('Error fetching onboarding progress:', error);
      }
    };

    fetchOnboardingProgress();
  }, []);


  useEffect(() => {
    dispatch(loadDashboardData({ startdate, enddate }));
  }, []);

  const { RangePicker } = DatePicker;

  // const onCalendarChange = (dates) => {
  //   // startdate = (dates?.[0]).format("YYYY-MM-DD");
  //   // enddate = (dates?.[1]).format("YYYY-MM-DD");
  //   startdate = dates?.[0] ? dayjs(dates[0]).toDate() : null;
  //   enddate = dates?.[1] ? dayjs(dates[1]).endOf("day").toDate() : null;

  //   dispatch(loadDashboardData({ startdate, enddate }));
  // };
  const onCalendarChange = (dates) => {
    const start = dates?.[0] ? dayjs(dates[0]).format("YYYY-MM-DD") : null;
    const end = dates?.[1] ? dayjs(dates[1]).format("YYYY-MM-DD") : null;
  
    setSelectedDates({ startdate: start, enddate: end });
    dispatch(loadDashboardData({ startdate: start, enddate: end }));
  };

  const config = {
    data,
    xField: "date",
    yField: "time",
    seriesField: "type",
    yAxis: {
      label: {
        formatter: (v) => `${v / 1000} Hours`,
      },
    },
    legend: {
      position: "top",
    },
    smooth: true,
    animation: {
      appear: {
        animation: "path-in",
        duration: 5000,
      },
    },
  };

  return (
    <Fragment>
      <UserPrivateComponent permission={"readAll-dashboard"}>
        <Row gutter={[30, 30]} justify={"space-between"}>
          {/* <Col span={24} >
            <SetupSteps />
          </Col>
          <Divider style={{ margin: '0px 0' }} /> */}

          {!isOnboardingComplete && (
            <>
              <Col span={24}>
                <SetupSteps />
              </Col>
              <Divider style={{ margin: '0px 0' }} />
            </>
          )}
          <Col sm={24} md={24} lg={12} span={24} className="mb-auto">
            <RangePicker
              onCalendarChange={onCalendarChange}
              defaultValue={defaultValue}
              format={"DD-MM-YYYY"}
              className="range-picker mr-3"
              style={{ maxWidth: "25rem" }}
            />
          </Col>

        </Row>

        <NewDashboardCard information={cardInformation} selectedDates={selectedDates}  />
      </UserPrivateComponent>
    </Fragment>
  );
};

export default DemoLine;
